import { EOFError } from "./EOFError.ts";

export class ByteReader {
  public position = 0;
  private data: DataView;
  private littleEndian = false;

  constructor(input: ArrayBufferView) {
    this.data = new DataView(input.buffer, input.byteOffset, input.byteLength);
  }

  get length() {
    return this.data.byteLength;
  }

  get bytesAvailable() {
    return this.length - this.position;
  }

  public readByte() {
    const position = this.advance(1);
    return this.data.getUint8(position);
  }

  public readUnsignedShort() {
    const position = this.advance(2);
    return this.data.getUint16(position, this.littleEndian);
  }

  public readUTF() {
    const length = this.readUnsignedShort();
    return this.readUTFBytes(length);
  }

  public readUTFBytes(length: number) {
    const position = this.advance(length);
    const { buffer, byteOffset } = this.data;
    const start = byteOffset + position;
    const end = start + length;
    return utf8Decoder.decode(buffer.slice(start, end));
  }

  private advance(length: number) {
    const position = this.position;
    const newPosition = position + length;
    if (this.length < newPosition) {
      throw new EOFError();
    }
    this.position = newPosition;
    return position;
  }
}

const utf8Decoder = new TextDecoder();
